<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input
              v-model="filterText"
              @keyup.enter="doFilter"
              type="text"
              class="form-control pull-right"
              placeholder="Pesquisar..."
            />
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <export-excel
          :fields="listaExcelFields"
          :fetch="gerarExcel"
          type="xls"
          worksheet="Avaliação de Performance"
          name="zanzar-avaliacao-performance.xls"
          class="btn btn-sm btn-primary btn-novo"
          style="width: 33px"
          data-tooltip="Exportar Excel"
        >
          <i class="fa fa-file-excel"></i>
        </export-excel>
      </div>
    </div>

    <filtro></filtro>

    <vuetable
      ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
    >
      <template slot="status_desc" slot-scope="props">
         <span
          class="label"
          style="display: inline-block; width: 100%;"
          v-bind:class="{
            'label-success': props.rowData.segmentacao == 'Verde',
            'label-warning': props.rowData.segmentacao == 'Amarelo',
            'label-danger': props.rowData.segmentacao == 'Vermelho'
          }"
        >&nbsp; </span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a
              @click="abrirGrafico(props.rowData)"
              class="btn btn-sm btn-default legitRipple"
              data-tooltip="Performance"
              data-delay="500"
              data-hasqtip="0"
              aria-describedby="qtip-0"
            >
              <span class="glyphicon glyphicon-stats"></span>
            </a>
          </div>
        </div>
      </template>
    </vuetable>
    <vuetable-pagination
      ref="pagination"
      :css="css.pagination"
      @vuetable-pagination:change-page="onChangePage"
    />

    <modal name="modal-evolucao" :adaptive="true" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-evolucao')">
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal}}</h3>
        </div>
        <div class="modal-body">
          <line-chart :chart-data="datacollection" :width="800" :height="600"></line-chart>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            @click="$modal.hide('modal-evolucao')"
          >Fechar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import {
  Vuetable,
  VuetablePagination,
  VuetablePaginationDropdown,
  VuetablePaginationBootstrap
} from "vuetable-2";
import LineChart from "./LineChart.js";
import Filtro from "./Filtro";
import Formatters from "../../helpers/Formatters";
import ApuracaoMensalActions from "../../actions/ApuracaoMensalActions";
import ActionsLogin from "../../actions/LoginActions";
import EventBus from './EventBus'
import moment from 'moment'

export default {
  name: "Listar",
  props: ["titulo", "status"],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationBootstrap,
    LineChart,
    filtro: Filtro
  },
  data() {
    return {
      titleModal: "",
      isModalPerfil: false,
      isModalImagemPerfil: false,
      imagemPerfil: "",
      historico: null,
      cdApuracao: null,
      errorMessageModal: "",
      errors: {},
      datacollection: null,
      listaExcelFields: {
        Motorista: 'nome',
        Telefone: 'tel_celular',
        Email: 'email',
        "Corrida Mês Anterior": 'viagens_realizadas_anterior',
        "Corrida Mês Atual": 'viagens_realizadas_atual',
        Evolução: 'evolucao'
      },
      filterText: "",
      urlApi: process.env.URL_API_BASE + "/apuracao-mensal/performance/listar",
      fields: [
        {
          name: "cd_motorista",
          title: "Código",
          sortField: "cd_motorista",
          visible: false
        },
        {
          name: "nome",
          title: "Motorista",
          sortField: '"motorista"."nome"'
        },
        {
          name: "tel_celular",
          title: "Telefone",
          sortField: '"motorista"."tel_celular"',
          callback: "formataNumeroTelefone"
        },
        {
          name: "email",
          title: "Email",
          sortField: '"motorista"."email"'
        },
        {
          name: "viagens_realizadas_anterior",
          title: "Corrida Mês Anterior",
          sortField: '"ApuracaoMensalAnterior"."viagens_realizadas"'
        },
        {
          name: "viagens_realizadas_atual",
          title: "Corrida Mês Atual",
          sortField: '"ApuracaoMensalAtual"."viagens_realizadas"'
        },
        {
          name: "evolucao",
          title: "Evolução",
          sortField: "evolucao"
        },
        {
          name: "__slot:status_desc",
          title: "Segmentação Mensal",
          sortField: "segmentacao"
        },
        "__slot:actions"
      ],
      sortOrder: [{ field: "motorista.nome", direction: "asc" }],
      moreParams: {},
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger"
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: ""
          }
        }
      }
    };
  },
  mounted() {
    this.$parent.$parent.$data.description = this.titulo;

    if(localStorage.getItem('filter_performance'))
      this.onFilterSearchSet(localStorage.getItem('filter_performance')) 

    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));

    EventBus.$on('pesquisar', (filtro) => {
      this.onFilterSearchSet(filtro);
    })

  },
  computed: {
    httpOptions() {
      return {
        headers: { Authorization: "Bearer " + ActionsLogin.getToken() }
      };
    }
  },
  watch: {
    status: function(val) {
      if (this.status !== null && this.status !== undefined) {
        this.$parent.$parent.$data.description = this.titulo;
        this.urlApi = process.env.URL_API_BASE + "/apuracao-mensal/";
      } else {
        this.$parent.$parent.$data.description = "Listar";
        this.urlApi = process.env.URL_API_BASE + "/apuracao-mensal";
      }
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onLoading() {
      this.$parent.$parent.$data.showModalLoader = true;
    },
    onLoaded() {
      this.$parent.$parent.$data.showModalLoader = false;
    },
    onFilterSet(filterText) {
      this.moreParams.filter = filterText;

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh();
        }
      });
    },
    doFilter() {
      this.$events.fire("filter-set", this.filterText);
    },
    doFilterSearch() {
      this.$events.fire("filter-search", '');
    },
    onFilterSearchSet(filtro) {
      this.moreParams.filtro = filtro;

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh();
        }
      });
    },
    view(rowData) {
      this.$router.push("/apuracao-mensal/" + rowData.cd_apuracao);
    },
    async gerarExcel() {
      let filtro = ""

      if (this.moreParams.filtro) {
        filtro = "&filtro=" + this.moreParams.filtro
      }

      let res = await ApuracaoMensalActions.listarMotoristasExcel(filtro)

      return res.data
    },
    formataNumeroTelefone(val) {
      return val != null ? Formatters.formataNumeroTelefone(val) : ''
    },
    formataData(val) {
      let data = moment.utc(val)
      
      if (data.isValid()) {
        return data.format('DD/MM/YYYY')
      }

      return ''
    },
    abrirGrafico(rowData) {
      this.titleModal = "Evolução Segmentações "
      this.fillData()

      ApuracaoMensalActions.listarHistoricoPorMotorista(rowData.cd_motorista)
        .then(res => {
          if (res) {
            this.fillData(
              res.map(e => {
                return e.competencia_mes + "/" + e.competencia_ano;
              }),
              res.map(e => e.viagens_realizadas)
            )
          }
        })
        .catch(error => {
          console.log(error.message);
          this.errorMessage = "Registro não encontrado."
        })

      this.$modal.show("modal-evolucao");
    },
    fillData(labels, data) {
      this.datacollection = {
        labels: labels,
        datasets: [
          {
            label: "Viagens realizadas",
            backgroundColor: "#605ca8",
            data: data
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Performance.vue